import { locationService } from "Apis";
import { useProjectSharedState } from "./useSharedState";
import { ApiLocationPageTagger, ApiProject } from "@incendium/api";

export const usePageTaggers = () => {
  const fetchPageTaggers = async (project: ApiProject) => {
    const res = await locationService.locationServiceListAllLocationPageTaggers({
      projectId: project.id as number,
      includeValues: true,
    });
    return res.results || [];
  };

  const { state, setState, refetch } = useProjectSharedState(
    "pageTaggers",
    [],
    fetchPageTaggers
  );

  return {
    pageTaggers: state as ApiLocationPageTagger[],
    setPageTaggers: setState,
    refetchPageTaggers: refetch,
  };
};
